<template>
  <div class="groupNotificationsControls">
    <div class="wrapper">
      <p v-if="titleLabel"><strong>{{ titleLabel }}</strong></p>
      <div v-if="debug">
        <small>Debug:</small>
        <p>Group: {{ groupID }}</p>
        <p>User: {{ userID }}</p>
        <p>Consent: {{ consent }}</p>
        <p>Aggregate: {{ aggregate }}</p>
        <p>hideAggregate: {{ hideAggregate === true }}</p>
      </div>
      <div>
        <v-checkbox v-model="consent" :label="consentLabel" :messages="consentHelp"
          :hide-details="consentHelp.length < 1 || consentHelp[0].length < 1" color="primary"
          class="align-top v-align-top d-inline-flex"></v-checkbox>
      </div>
      <div>
        <v-checkbox v-model="aggregate" :label="aggregateLabel" :messages="aggregateHelp"
          :hide-details="aggregateHelp.length < 1 || aggregateHelp[0].length < 1" v-if="hideAggregate !== true"
          :disabled="!consent" color="primary" class="align-top v-align-top d-inline-flex" inline>
        </v-checkbox>
      </div>

    </div>
  </div>
</template>
<style lang="scss" scoped>
::v-deep .v-input--checkbox {
  .v-input__slot {
    align-items: start;
  }
}
</style>
<script>
export default {
  props: [
    'debug',
    'groupID',
    'userID',
    'consent',
    'aggregate',
    'title',
    'labelEmailPermitted',
    'labelEmailDeclined',
    'labelEmailAggregate',
    'labelEmailIndividual',
    'helpTextEmailPermitted',
    'helpTextAggregate',
    'hideAggregate'
  ],
  emits: [
    'groupNotificationsPermitted',
    'groupNotificationsDeclined',
    'groupNotificationsAggregated',
    'groupNotificationsIndividual',
    'groupNotificationPermissionChanged',
    'groupNotificationAggregateChanged',
    'groupNotificationsSettingsChanged'
  ],
  data() {
    return {

    };
  },
  watch: {
    consent(newValue) {
      this.$emit('groupNotificationsSettingsChanged', 'Settings Changed', this.groupID, this.userID, this.consent, this.aggregate);
      this.$emit('groupNotificationPermissionChanged', 'Permission Changed', this.groupID, this.userID, this.consent);
      if (newValue) {
        this.$emit('groupNotificationsPermitted', 'Notifications Permitted', this.groupID, this.userID);
      } else {
        this.$emit('groupNotificationsDeclined', 'Notifications Declined', this.groupID, this.userID)
      }
    },
    aggregate(newValue) {
      this.$emit('groupNotificationsSettingsChanged', 'Settings Changed', this.groupID, this.userID, this.consent, this.aggregate);
      this.$emit('groupNotificationAggregateChanged', 'Aggregate Changed', this.groupID, this.userID, this.aggregate);
      if (newValue) {
        this.$emit('groupNotificationsAggregated', 'Notifications Aggregated', this.groupID, this.userID);
      } else {
        this.$emit('groupNotificationsIndividual', 'Notifications Individual', this.groupID, this.userID)
      }
    }
  },
  computed: {
    titleLabel() {
      return this.title || typeof this.title === 'string' ? this.title : 'Group Notification Email Settings';
    },
    consentLabel() {
      return this.labelEmailPermitted || 'I want activity notification emails from this group.';
    },
    aggregateLabel() {
      return this.labelEmailAggregate || 'I want fewer activity notification emails from this group.';
    },
    consentHelp() {
      return [
        this.helpTextEmailPermitted || 'If checked, you will receive activity notification emails regarding new posts and relevant comments added to this group.'
      ];
    },
    aggregateHelp() {
      return [
        this.helpTextAggregate || 'If checked, you will receive a periodic activity notification email summarizing recent group activity instead of individual notifications for each update.'
      ];
    }
  }
};
</script>
